import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';

import Flex from 'quarks/Flex';
import Image from 'quarks/Image';
import Link from 'quarks/Link';
import Text from 'quarks/Text';

import richTextParser from 'utils/richTextParser';

import type { ContentfulEntityPerson } from 'graphqlTypes';
import type { FC } from 'react';

interface SidebarAuthorProps extends ContentfulEntityPerson {
  readTime: string;
  publishDate?: string;
}

const SidebarAuthor: FC<SidebarAuthorProps> = ({
  fullName,
  biography,
  headshot,
  readTime,
  publishDate,
  twitterUrl,
  facebookUrl,
  linkedInUrl,
  instagramUrl,
}) => {
  const hasSocialLinks = !!(twitterUrl || facebookUrl || linkedInUrl || instagramUrl);
  const socialLinks = [
    {
      site: 'linkedin',
      url: linkedInUrl,
    },
    {
      site: 'twitter',
      url: twitterUrl,
    },
    {
      site: 'facebook',
      url: facebookUrl,
    },
    {
      site: 'instagram',
      url: instagramUrl,
    },
  ] as const;

  return (
    <Flex flexDirection="column" gap="24px">
      <Text textStyle="eyebrowLg" fontWeight="extraBold">
        Written By
      </Text>
      <Flex gap="16px">
        {headshot ? (
          <Image alt={`Blog Author - ${fullName}`} image={headshot} width="60px" height="60px" borderRadius="50%" />
        ) : (
          <Icon id="avatar-light-blue-circle" size={60} />
        )}
        <Flex flexDirection="column" justifyContent="center">
          <Text textStyle="lg" fontWeight="bold" textColor="gray-900">
            {fullName}
          </Text>
          <Flex alignItems="center">
            <Text textStyle="md" textColor="gray-700">
              {publishDate} • {readTime}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      {biography && (
        <Text
          as={Flex}
          textStyle="md"
          textColor="gray-900"
          css={`
            flex-direction: column;
            gap: 8px;
          `}
        >
          {richTextParser(biography)}
        </Text>
      )}
      {hasSocialLinks && (
        <Flex gap="16px">
          {socialLinks.map(
            ({ url, site }) =>
              url && (
                <Link key={url} href={url}>
                  <Icon id={site} size={24} fill={color.primary[500]} />
                </Link>
              ),
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default SidebarAuthor;
